import React, { Component } from 'react';

import { Form, Row, Col, Modal, Select, } from 'antd';
import { Message } from 'semantic-ui-react'

const FormItem = Form.Item;
const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 14 },
  };
class FundBookAddDialog extends Component {

    constructor(props){
      super();
      this.state = {
        errorMsg: null
      };
    }

    onInputChange = ({name, value}) => {
        this.props.restrictedRuleEditChangeInput({name, value});
    }

    fundCodeOnChange = (value) => {
        const {
            fundBookFields
        } = this.props.restrictedRuleEditControlModal;
        const updatedFields = {
            ...fundBookFields,
            fund: value
        }
        this.props.restrictedRuleEditChangeInput({ name: 'fundBookFields', value: updatedFields });
        this.setState({
          errorMsg: null
        });
    }
    
    bookCodeOnChange = (value) => {
        const {
            fundBookFields
        } = this.props.restrictedRuleEditControlModal;
        const updatedFields = {
            ...fundBookFields,
            book: value
        }
        this.props.restrictedRuleEditChangeInput({ name: 'fundBookFields', value: updatedFields });
        this.setState({
          errorMsg: null
        });
      }

    submitButtonOnClicked = () => {
      const {
        fundBookFields,
        fields
      } = this.props.restrictedRuleEditControlModal;

      let fundBookList = fields.fundBookList;
      //check exists
      if(fundBookList){
        const result = fundBookList.filter(r => 
          r.fund === fundBookFields.fund && r.book === fundBookFields.book);
          if(result && result.length>0){
            this.setState({
              errorMsg: 'Current config has exists'
            });
            return;
          }
        }
        fundBookList = fundBookList?fundBookList:[];
        fundBookList.push(fundBookFields);
        const updatedFields ={
          ...fields,
          fundBookList
        }
        this.props.restrictedRuleEditChangeInput({ name: 'fields', value: updatedFields });
        this.props.closeRestrictedRuleFundBookDialog();
      }

    render(){
        const {
            isFundBookOpened,
            fundBookFields,
          } = this.props.restrictedRuleEditControlModal;
          const {
            fundCodeOptions,
            bookCodeOptions,
          } = this.props;

        return(
        <div>
        <Modal
          title={"Fund Book Add"}
          centered
          width={1000}
          visible={isFundBookOpened}
          onOk={this.submitButtonOnClicked}
          onCancel={() => this.props.closeRestrictedRuleFundBookDialog()}
          destroyOnClose={true}
          maskClosable={false}
          okText="Submit"
          cancelText="Cancel"
        >
          <Form layout="horizontal">
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Fund">
                      <Select 
                        allowClear
                        showSearch
                        value={fundBookFields.fund}
                        onChange={this.fundCodeOnChange} 
                        placeholder="Please Choose"
                        >
                        {fundCodeOptions}
                      </Select>
                </FormItem>
              </Col>
              <Col span={12}>
              <FormItem {...formItemLayout} label="Book">
                      <Select 
                        allowClear
                        showSearch
                        value={fundBookFields.book}
                        onChange={this.bookCodeOnChange} 
                        placeholder="Please Choose"
                        >
                        {bookCodeOptions}
                      </Select>
                </FormItem>
              </Col>
            </Row>
            {
            this.state.errorMsg &&  
             <Message negative>
                <Message.Header>Response Error Message</Message.Header>
              <p>{ this.state.errorMsg }</p>
            </Message>
          }
        </Form>    
        </Modal>

        </div>)
    }
}

export default FundBookAddDialog;